(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('direct-register', {
            url: '/direct-register',
            templateUrl: 'app/account/direct-register/direct-register.html',
            controller: 'DirectRegisterController',
            controllerAs: 'vm',
            data: {
                authorities: [],
                pageTitle: 'Register to Kaztor',
                specialClass: 'direct-register'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
